<div class="page-title-area" *ngIf="jobDetails" >
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                 
                   <h3 class="text-white" routerLink="/organization/{{jobDetails.organizationId}}" style="cursor: pointer;">{{jobDetails?.companyName}}</h3>
                    <h2>{{jobDetails.title}}</h2>
                    <ul>
                        <li><a routerLink="/job-list">Vakaturanan</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li ><a routerLink="/organization/{{jobDetails.organizationId}}">{{jobDetails.companyName}}</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>Job Details</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="job-details-area pt-100" *ngIf="jobDetails" >
    <div class="container ">
        <div class="row">

            <div class="col-lg-4 d-block d-lg-none">
                <div class="job-details-item">
                    <div class="job-overview">
                        <h3>Overview</h3>

                        <ul>
                            <li>
                                <i class="icofont-dollar"></i>
                                <p>Salaris</p>
                                <span> {{jobDetails.salary}}</span>
                            </li>

                            <li>
                                <i class="icofont-badge"></i>
                                <p>Ervaring</p>
                                <span> {{jobDetails.experience}}</span>
                            </li>

                            <li>
                                <i class="icofont-graduate"></i>
                                <p>Opleiding</p>
                                <span> {{jobDetails.qualification}}</span>
                            </li>
                            <li *ngIf="jobDetails.organizationId !='11'">
                               <p>Bezoldigingsschalen</p> 
                            <a href="https://mevoz.net/minjus/Bezoldigingsschalen.pdf" target="_blank" class="text-black"><i class="icofont-download"></i> Download</a>
                            </li>
                        </ul>
                        
                    </div>
                  <div></div>
                  <div *ngIf="!isLoggedIn">
                    <a routerLink="/login" class="btn btn-lg btn-block" style="background:#0b1c38; color:#fff; border-radius:0px; width:100%;">Login pa Apliká</a>
                  </div>
                  <div *ngIf="isLoggedIn">
           <div *ngIf="jobDetails.id=='95'">
                       <a href="https://polis.cw/vakatura/" target="_blank"><button  class="btn btn-lg btn-block" style="background:#0b1c38; color:#fff; border-radius:0px; width:100%;">Apliká</button>
                       </a>
                       
                       
                    </div>
                    <div *ngIf="jobDetails.id=='96'">
                      <a href="https://polis.cw/vakatura/" target="_blank"><button  class="btn btn-lg btn-block" style="background:#0b1c38; color:#fff; border-radius:0px; width:100%;">Apliká</button>
                      </a>
                      
                      
                   </div>

                    <div *ngIf="jobDetails.organizationId=='16'">
                      <a href="https://werkenbij.omcarib.org/ " target="_blank"><button  class="btn btn-lg btn-block" style="background:#0b1c38; color:#fff; border-radius:0px; width:100%;">Apliká</button>
                      </a>
                      
                      
                   </div>

                   <div *ngIf="isLoggedIn && jobDetails.id != '95' && jobDetails.id != '96' && jobDetails.organizationId != '16'">

                        <!-- Apply Button with Validation -->
                        <button *ngIf="!hasApplied && !isTokenValidating && !isApplying" (click)="validateAndApplyForJob(jobDetails.id, jobDetails.organizationId)" class="btn btn-lg btn-block" style="background:#0b1c38; color:#fff; border-radius:0px; width:100%;">Apliká</button>
                        
                        <!-- Spinner for Token Validation -->
                        <div *ngIf="isTokenValidating" class="text-center">
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Validating...
                        </div>
                        
                        <!-- Spinner for Applying State -->
                        <div *ngIf="isApplying" class="text-center">
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Applying...
                        </div>
                        
                        <!-- Applied State Button -->
                        <button *ngIf="hasApplied" class="btn btn-success btn-lg btn-block" style="color:#fff; border-radius:0px; width:100%;">Bo a Apliká <i class="icofont-check"></i></button>
                    </div>
                      
                
                  </div>

                    
                </div>

                   
                <div class="job-details-item" *ngIf="availableTimeSlots.length > 0;">
                    <div class="job-overview">
                      <h3>Job Dating</h3>
                      <!-- Display the booking form if there are available slots -->
                      <div *ngIf="availableTimeSlots.length > 0">
                        <label for="id_select">Skohe un orario:</label>
                        <select [(ngModel)]="selectedInterval" class="form-select" id="id_select" style="color:#0b1c38;">
                          <ng-container *ngFor="let timeSlot of availableTimeSlots">
                            <optgroup [label]="timeSlot.date | date: 'fullDate'">
                              <option *ngFor="let interval of timeSlot.availableIntervals" [ngValue]="interval">
                                {{ interval.start }} - {{ interval.end }}
                              </option>
                            </optgroup>
                          </ng-container>
                        </select>
                        <button class="btn btn-lg btn-block mt-4" [class.loading]="isLoading" (click)="bookTimeSlot()" [disabled]="isLoading" style="background:#0b1c38; color:#fff; border-radius:0px; width:100%;">
                            <span *ngIf="!isLoading">Book Sita</span>
                            <span *ngIf="isLoading">Loading...</span>
                          </button>
                      </div>
                    </div>
                  </div>
                  
                  <div class="job-details-item" *ngIf="bookingDetails.length > 0;">
                    <div class="job-overview">
                    <h3>Bo Sita:</h3>
                    <ul>
                      <li *ngFor="let detail of bookingDetails">
                        Number di Booth: {{ detail.boothId }} <br />
                        Fecha: {{ detail.date | date: 'fullDate' }} <br /> 
                        Orario: {{ detail.start_time }} - {{ detail.end_time }}
                      </li>
                    </ul>
                  </div>
                  </div>


            </div>
            <div class="col-lg-8">
                <div class="job-details-item">
                    <div class="job-description">
                        <h2>Functie</h2>
                        <div *ngIf="jobDetails" [innerHTML]="jobDetails.description"></div>

                    </div>

                    <div class="job-knowledge">
                        <h2>Jouw taken en verantwoordelijkheden:</h2>

                        <div *ngIf="jobDetails" [innerHTML]="jobDetails.skills"></div>
                    </div>
                    
                    <div class="job-knowledge">
                        <h2>Jouw Profiel</h2>
                        <div *ngIf="jobDetails" [innerHTML]="jobDetails.education"></div>
                       
                    </div>

                    <div class="text-center">
                     <!--   <a class="job-details-btn" routerLink="/create-account">Apply Now</a>    -->
                    </div>
                </div>
            </div>
            <div class="col-lg-4 d-none d-lg-block">
                <div class="job-details-item">
                    <div class="job-overview">
                        <h3>Overview</h3>

                        <ul>
                            <li>
                                <i class="icofont-dollar"></i>
                                <p>Salaris</p>
                                <span> {{jobDetails.salary}}</span>
                            </li>

                            <li>
                                <i class="icofont-badge"></i>
                                <p>Ervaring</p>
                                <span> {{jobDetails.experience}}</span>
                            </li>

                            <li>
                                <i class="icofont-graduate"></i>
                                <p>Opleiding</p>
                                <span> {{jobDetails.qualification}}</span>
                            </li>
                            <li *ngIf="jobDetails.organizationId !='11'">
                                <p>Bezoldigingsschalen</p> 
                             <a href="https://mevoz.net/minjus/Bezoldigingsschalen.pdf" target="_blank" class="text-black"><i class="icofont-download"></i> Download</a>
                             </li>
                        </ul>
                        
                    </div>

             <!-- Conditionally display no available slots message -->




                 
                    <div *ngIf="!isLoggedIn">
                        <a routerLink="/login" class="btn btn-lg btn-block" style="background:#0b1c38; color:#fff; border-radius:0px; width:100%;">Login pa Apliká</a>
                      </div>
                      <div *ngIf="isLoggedIn">
               <div *ngIf="jobDetails.id=='95'">
                           <a href="https://polis.cw/vakatura/" target="_blank"><button  class="btn btn-lg btn-block" style="background:#0b1c38; color:#fff; border-radius:0px; width:100%;">Apliká</button>
                           </a> 
                        </div>


                        <div *ngIf="jobDetails.id=='96'">
                          <a href="https://polis.cw/vakatura/" target="_blank"><button  class="btn btn-lg btn-block" style="background:#0b1c38; color:#fff; border-radius:0px; width:100%;">Apliká</button>
                          </a> 
                       </div>

                        <div *ngIf="jobDetails.organizationId=='16'">
                          <a href="https://werkenbij.omcarib.org/ " target="_blank"><button  class="btn btn-lg btn-block" style="background:#0b1c38; color:#fff; border-radius:0px; width:100%;">Apliká</button>
                          </a>
                          
                          
                       </div>

                       <div *ngIf="isLoggedIn && jobDetails.id != '95' && jobDetails.id != '96' && jobDetails.organizationId != '16'">
                            <!-- Apply Button with Validation -->
                            <button *ngIf="!hasApplied && !isTokenValidating && !isApplying" (click)="validateAndApplyForJob(jobDetails.id, jobDetails.organizationId)" class="btn btn-lg btn-block" style="background:#0b1c38; color:#fff; border-radius:0px; width:100%;">Apliká</button>
                            
                            <!-- Spinner for Token Validation -->
                            <div *ngIf="isTokenValidating" class="text-center">
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Validating...
                            </div>
                            
                            <!-- Spinner for Applying State -->
                            <div *ngIf="isApplying" class="text-center">
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Applying...
                            </div>
                            
                            <!-- Applied State Button -->
                            <button *ngIf="hasApplied" class="btn btn-success btn-lg btn-block" style="color:#fff; border-radius:0px; width:100%;">Bo a Apliká <i class="icofont-check"></i></button>
                        </div>
                    
                      </div>
                    </div>




                   
                   <div class="job-details-item" *ngIf="availableTimeSlots.length > 0;">
                    <div class="job-overview">
                      <h3>Job Dating</h3>
                      <!-- Display the booking form if there are available slots -->
                      <div *ngIf="availableTimeSlots.length > 0;">
                        <label for="id_select">Skohe un orario:</label>
                        <select [(ngModel)]="selectedInterval" class="form-select" id="id_select" style="color:#0b1c38;">
                          <ng-container *ngFor="let timeSlot of availableTimeSlots">
                            <optgroup [label]="timeSlot.date | date: 'fullDate'">
                              <option *ngFor="let interval of timeSlot.availableIntervals" [ngValue]="interval">
                                {{ interval.start }} - {{ interval.end }}
                              </option>
                            </optgroup>
                          </ng-container>
                        </select>
                        <button class="btn btn-lg btn-block mt-4" [class.loading]="isLoading" (click)="bookTimeSlot()" [disabled]="isLoading" style="background:#0b1c38; color:#fff; border-radius:0px; width:100%;">
                            <span *ngIf="!isLoading">Book Sita</span>
                            <span *ngIf="isLoading">Loading...</span>
                          </button>
                      </div>
                      
                    </div>
                    
                  </div>
                  <div>


                   <div class="job-details-item" *ngIf="bookingDetails.length > 0;">
                    <div class="job-overview">
                    <h3>Bo Sita:</h3>
                    <ul>
                      <li *ngFor="let detail of bookingDetails">
                        Number di Booth: {{ detail.boothId }} <br />
                        Fecha: {{ detail.date | date: 'fullDate' }} <br /> 
                        Orario: {{ detail.start_time }} - {{ detail.end_time }}
                      </li>
                    </ul>
                  </div>
                  </div>
                  </div>
                  <!-- Template for displaying booking details -->
  
   

                  
                
                  
                  
   
                    
                
            </div> 
            
        </div>
    </div>
</div>